import { render, staticRenderFns } from "./email.vue?vue&type=template&id=7bbe6cf1&scoped=true"
import script from "./email.vue?vue&type=script&lang=js"
export * from "./email.vue?vue&type=script&lang=js"
import style0 from "./email.vue?vue&type=style&index=0&id=7bbe6cf1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbe6cf1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bbe6cf1')) {
      api.createRecord('7bbe6cf1', component.options)
    } else {
      api.reload('7bbe6cf1', component.options)
    }
    module.hot.accept("./email.vue?vue&type=template&id=7bbe6cf1&scoped=true", function () {
      api.rerender('7bbe6cf1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notify/systemScene/components/email.vue"
export default component.exports